<template>
  <q-page class="main no-sticky-header">
    <div class="row justify-center">
      <q-card class="page-card col-xs-12 col-md-8">
        <q-card-section class="page-card__main-content">
          <div class="row items-center justify-between q-mb-lg">
            <h1 class="heading-2">Berichten</h1>
            <flat-button v-if="notifications.total > 0 && $isDesktop" label="Markeer alles als gelezen" color="accent"
                         icon="mark_email_read" @click="markAllAsRead" />
            <icon-button v-if="notifications.total > 0 && !$isDesktop" aria-label="Markeer alles als gelezen"
                         color="accent" icon="mark_email_read" @click="markAllAsRead" outlined />
          </div>
          <q-list v-if="notifications.data.length > 0" bordered separator class="rounded-borders">
            <q-item v-for="notification in notifications.data" :key="notification.id">
              <q-item-section>
                <div class="row items-center q-col-gutter-x-md">
                  <q-item-label>
                    <common-link :label="notification.message" :href="`/${notification.link}`"
                                 :class="{'text-weight-bold': !notification.is_read}" />
                  </q-item-label>
                </div>
              </q-item-section>
              <q-item-section side>
                <div class="row items-center">
                <span class="q-mr-sm">
                  {{ notification.type }}
                  <!--                  {{ $formatDateRelative(notification.created_at) }}-->
                </span>
                </div>
              </q-item-section>
            </q-item>
            <q-item v-if="notifications.last_page > 1" class="flex flex-center">
              <pagination-links :items="notifications" />
            </q-item>
          </q-list>
          <template v-else>
            <q-separator />
            <p class="q-mt-lg">
              U heeft geen berichten.
            </p>
          </template>
        </q-card-section>
      </q-card>
    </div>
  </q-page>
</template>

<script>
export default {
  props: {
    notifications: {
      type: Object,
      default: () => ({}),
    },
  },
  methods: {
    markAllAsRead () {
      $goto('auth.notifications.mark-as-read')
    },
  },
}
</script>
